import f3tch from 'f3tch';

// Constants
import API_URL from '../../api/constants/url.constant.api';

// Profiles
import profile from '../../api/profiles/json.profile.api';

const orderApi = (order) =>
  f3tch('/order')
    .profile(profile({url: API_URL()}))
    .body(order)
    .post();

export default orderApi;
